export default {
	model: {
		prop: 'checked',
		event: 'change'
	},
	props: {
		/**
		 * The id attribute of the checkbox.
		 */
		id: String,
		/**
		 * The id attribute of the radio.
		 */
		name: String,
		/**
		 * Label of the checkbox.
		 */
		label: String,
		/**
		 * Description of the checkbox.
		 */
		description: String,
		/**
		 * The value attribute of the radio.
		 */
		value: { default: false },
		/**
		 * The checked attribute of the radio.
		 */
		checked: {
			type: Boolean,
			default: false,
		},
		/**
		 * Makes the input element disabled.
		 */
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		inputListeners() {
			return {
				...this.$listeners,
				change: (event) => {
					this.$emit('change', event.target.checked);
				}
			};
		}
	}
};